export default {
  apiKey: "AIzaSyD-CygictQXLXNYs5XfH-X83G8WyARa6ok",
  authDomain: "test-je-werkgeluk-acc-5213b.firebaseapp.com",
  databaseURL: "https://test-je-werkgeluk-acc-5213b.firebaseio.com",
  projectId: "test-je-werkgeluk-acc-5213b",
  storageBucket: "",
  messagingSenderId: "189520909666"
}



// WEBPACK FOOTER //
// ./src/components/firebaseConfigAcc.js